import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import defaultLang, { en_US, fa_IR } from "../../constants/locales";
import en from "../../locales/en-US/translation.json";
import fa from "../../locales/fa-IR/translation.json";

const resources = {
  [en_US]: {
    translation: en,
  },
  [fa_IR]: {
    translation: fa,
  },
};

i18n.use(initReactI18next).init({
  resources,
  lng: defaultLang,

  keySeparator: false,
  nsSeparator: false,

  interpolation: {
    escapeValue: false, // react already safes from xss
  },
});

export default i18n;
